exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fa-asterisk[data-v-2c1bef82]{color:#c62828;font-size:.698rem}.atras[data-v-2c1bef82]{padding-left:25px;padding-right:25px}.form-control[data-v-2c1bef82]{text-transform:uppercase}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c1bef82","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Paso2.vue
// module id = 163
// module chunks = 0